import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Card,
  Col,
  Descriptions,
  Popconfirm,
  Row,
  Space,
  Tabs,
} from "antd";
import { UserOutlined, FileTextOutlined } from "@ant-design/icons";
import { ReactComponent as UserSvg } from "../../../assets/images/description/User.svg";
import { ReactComponent as EmailSvg } from "../../../assets/images/description/Message.svg";
import { ReactComponent as CalenderSvg } from "../../../assets/images/description/calendar.svg";
import { ReactComponent as ThemeSvg } from "../../../assets/images/description/Color Palette.svg";
import { ReactComponent as SubscriptionSvg } from "../../../assets/images/description/Crown.svg";
import { ReactComponent as AdvertisementSvg } from "../../../assets/images/description/Camera.svg";
import { useLocation, useNavigate } from "react-router";
import Img1 from "../../../assets/images/img1.png";
import { ReactComponent as EditSvg } from "../../../assets/images/action/edit.svg";
import { ReactComponent as DeactivateSvg } from "../../../assets/images/action/deactivate.svg";
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/deleteWhite.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTenantFun,
  fetchAdminCategory,
  viewTenantFun,
} from "../../../redux/reducer/TenantSlice";
import { ArrowLeftOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import { imageUrl } from "../../../constants/ApiConstant";
import ContentScalaton from "../../../components/scalaton/ContentScalaton";
import ViewTenantUser from "./ViewTenantUser";
import UserListView from "./UserListView";
const { TabPane } = Tabs;

// Breakpoints
const descriptions_breakpoint = {
  xxl: 4,
  xl: 4,
  lg: 3,
  md: 3,
  sm: 2,
  xs: 1,
};
const ViewTenantDetails = () => {
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const location = useLocation();
  const { tenantDetails, deleteTenantLoading, viewtenantDetails, loading } =
    useSelector((state) => state.tenant);
  const { listCategoryTenant, listCategoryTenantLoading } = useSelector(
    (state) => state.tenant
  );

  const handleDelete = async (id) => {
    try {
      const data = await dispatch(deleteTenantFun(id));

      if (data?.type === "data/delete/tenant/fulfilled") {
        navigate("/tenant-mgmnt");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = (data) => {
    if (data) {
      navigate("/tenant-mgmnt/edit-tenant", { state: { tenentData: data } });
    }
  };

  const [tenantData, setTenantData] = useState(null);

  useEffect(() => {
    const storedData = localStorage.getItem("tenantData");
    if (storedData) {
      setTenantData(JSON.parse(storedData));
    }
  }, []);

  // Update when location.state.tenantData is available
  useEffect(() => {
    const newTenant = location?.state?.tenantData;

    if (newTenant && newTenant.id !== tenantData?.id) {
      setTenantData(newTenant);
      localStorage.setItem("tenantData", JSON.stringify(newTenant)); // Save to localStorage
    }
  }, [location?.state]);

  useEffect(() => {
    if (tenantData) {
      dispatch(viewTenantFun(tenantData?.id));
      dispatch(fetchAdminCategory(tenantData?.id));
    }
  }, [dispatch, tenantData]);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };
  const data = [];

  const user_details = [
    {
      key: "1",
      label: (
        <>
          <UserSvg /> User’s Name
        </>
      ),
      children: viewtenantDetails?.name_en ?? "user",
    },
    {
      key: "2",
      label: (
        <>
          <EmailSvg /> Email
        </>
      ),
      children: viewtenantDetails?.email ?? "user",
    },
  ];

  const basicInfo_details = [
    {
      key: "1",
      label: (
        <>
          <UserSvg /> Tenant’s Name
        </>
      ),
      children: viewtenantDetails?.name_en ?? "user",
    },
    {
      key: "2",
      label: (
        <>
          <EmailSvg /> Email
        </>
      ),
      children: viewtenantDetails?.email ?? "user",
    },
    {
      key: "2",
      label: (
        <>
          <UserSvg /> Contact Person
        </>
      ),
      children: viewtenantDetails?.contact_person_en ?? "user",
    },
    {
      key: "2",
      label: (
        <>
          <UserSvg /> Mobile Number
        </>
      ),
      children: viewtenantDetails?.mobile_no ?? "user",
    },
    {
      key: "3",
      label: (
        <>
          <UserSvg /> Total Users
        </>
      ),
      children: viewtenantDetails?.total_user ?? "user",
    },
    {
      key: "4",
      label: (
        <>
          <CalenderSvg /> Date Added
        </>
      ),
      children:
        dayjs(viewtenantDetails?.created_at).format("MM-DD-YYYY") ?? "user",
    },
    {
      key: "5",
      label: (
        <>
          <ThemeSvg /> Primary Color
        </>
      ),
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10pxs",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px", // Adjust width as needed
              backgroundColor: viewtenantDetails?.primary_color ?? "#ccc", // Default color if not provided
              borderRadius: "5px",
              border: "1px solid #000", // Optional: adds a border to the box
              display: "inline-block",
              marginRight: "10px",
            }}
          ></div>
          {viewtenantDetails?.primary_color ?? "user"}
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <ThemeSvg /> Primary Text Color
        </>
      ),
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10pxs",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px", // Adjust width as needed
              backgroundColor: viewtenantDetails?.font_color ?? "#000", // Default color if not provided
              borderRadius: "5px",
              border: "1px solid #000", // Optional: adds a border to the box
              display: "inline-block",
              marginRight: "10px",
            }}
          ></div>
          {viewtenantDetails?.font_color ?? "user"}
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <ThemeSvg /> Background Color
        </>
      ),
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10pxs",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px", // Adjust width as needed
              backgroundColor: viewtenantDetails?.bg_color ?? "#000", // Default color if not provided
              borderRadius: "5px",
              border: "1px solid #000", // Optional: adds a border to the box
              display: "inline-block",
              marginRight: "10px",
            }}
          ></div>
          {viewtenantDetails?.bg_color ?? "user"}
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <ThemeSvg /> Secondary Text Color
        </>
      ),
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10pxs",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px", // Adjust width as needed
              backgroundColor: viewtenantDetails?.text_color ?? "#000", // Default color if not provided
              borderRadius: "5px",
              border: "1px solid #000", // Optional: adds a border to the box
              display: "inline-block",
              marginRight: "10px",
            }}
          ></div>
          {viewtenantDetails?.text_color ?? "user"}
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <ThemeSvg /> Button Color
        </>
      ),
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10pxs",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px", // Adjust width as needed
              backgroundColor: viewtenantDetails?.btn_color ?? "#000", // Default color if not provided
              borderRadius: "5px",
              border: "1px solid #000", // Optional: adds a border to the box
              display: "inline-block",
              marginRight: "10px",
            }}
          ></div>
          {viewtenantDetails?.btn_color ?? "user"}
        </div>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <ThemeSvg /> Button Text Color
        </>
      ),
      children: (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10pxs",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px", // Adjust width as needed
              backgroundColor: viewtenantDetails?.btn_text_color ?? "#000", // Default color if not provided
              borderRadius: "5px",
              border: "1px solid #000", // Optional: adds a border to the box
              display: "inline-block",
              marginRight: "10px",
            }}
          ></div>
          {viewtenantDetails?.btn_text_color ?? "user"}
        </div>
      ),
    },
    {
      key: "7",
      label: (
        <>
          <SubscriptionSvg /> Subscription Plan
        </>
      ),
      children: viewtenantDetails?.subscription_name_en ?? "user",
    },
    {
      key: "8",
      label: (
        <>
          <CalenderSvg /> Subscription Duration
        </>
      ),
      children:
        `${dayjs(viewtenantDetails?.subscription_start_date).format(
          "MM-DD-YYYY"
        )} - ${dayjs(viewtenantDetails?.subscription_end_date).format(
          "MM-DD-YYYY"
        )}` ?? "user",
    },
    {
      key: "9",
      label: (
        <>
          <AdvertisementSvg /> Advertisement managed by
        </>
      ),
      children: viewtenantDetails?.manage_advt ? "Tenant" : "Admin",
    },
    {
      key: "11",
      label: (
        <>
          <AdvertisementSvg /> Default Language
        </>
      ),
      children:
        viewtenantDetails?.default_language === 1
          ? "English"
          : viewtenantDetails?.default_language === 2
          ? "Spanish"
          : viewtenantDetails?.default_language === 3
          ? "Portuguese"
          : "N/A",
    },
    {
      key: "10",
      label: (
        <>
          <UserSvg /> Max User Allowed
        </>
      ),
      children: viewtenantDetails?.max_user ?? "N/A",
    },
    {
      key: "10",
      label: (
        <>
          <UserSvg />
          Restricted IP
        </>
      ),
      children: viewtenantDetails?.ip_address ?? "N/A",
    },
  ];
  return (
    <>
      <div className="viewTenant">
        <div className="tableHeading">
          <ArrowLeftOutlined
            onClick={() => navigate("/tenant-mgmnt")}
            style={{ fontSize: "18px", marginRight: "10px" }}
          />
          View Tenant Details
        </div>
        {activeTab === "1" ? (
          <Space>
            <Button
              type="text"
              onClick={() => handleEdit(tenantData)}
              icon={<EditSvg />}
              className="editTextBtn"
            >
              Edit Details
            </Button>{" "}
            {/* <Button
            // onClick={() => navigate("add-tenant")}
            icon={<DeactivateSvg />}
            className="deactivate"
          >
            Deactivate
          </Button> */}
            <Popconfirm
              title={
                <span style={{ fontWeight: 600, fontSize: "16px" }}>
                  Delete Tenant?
                </span>
              }
              description={
                <span style={{ color: "#999" }}>
                  This action cannot be undone.
                </span>
              }
              onConfirm={() => handleDelete(tenantData?.id)}
              okText="Yes, Delete"
              cancelText="Cancel"
              okButtonProps={{ danger: true, style: { borderRadius: 6 } }}
              cancelButtonProps={{ style: { borderRadius: 6 } }}
              placement="topRight"
              overlayStyle={{ width: 300 }}
            >
              <Button
                type="primary"
                danger
                icon={<DeleteSvg />}
                className="delete"
                loading={deleteTenantLoading}
              >
                Delete
              </Button>
            </Popconfirm>
          </Space>
        ) : (
          ""
        )}
      </div>
      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          type="card"
          tabBarStyle={{ color: "#45AE51", fontWeight: "bold" }}
          className="custom-tabs"
        >
          <TabPane tab="General Details" key="1">
            {loading ? (
              <ContentScalaton />
            ) : (
              <Row gutter={[16, 16]}>
                <Col xs={24} md={18}>
                  <div className="customDescription">
                    <Descriptions
                      className="custom_descriptions"
                      layout="vertical"
                      items={basicInfo_details}
                      size="small"
                      column={{ xs: 1, sm: 2, md: 3 }}
                    />
                  </div>
                </Col>
                <Col xs={24} md={6}>
                  <Avatar
                    size={120}
                    src={
                      viewtenantDetails?.logo
                        ? `${imageUrl}${viewtenantDetails?.logo}`
                        : undefined
                    } // Use the correct base URL
                    icon={
                      !viewtenantDetails?.logo ? <UserOutlined /> : undefined
                    }
                    alt="User Img"
                    style={{
                      backgroundColor: viewtenantDetails?.logo
                        ? "transparent"
                        : "#45AE51", // If logo exists, remove background color
                      color: "#fff",
                      border: "2px solid #fff",
                      boxShadow: "0px 1px 2px rgba(0,0,0,0.2)",
                    }}
                  />
                </Col>
              </Row>
            )}
          </TabPane>
          <TabPane tab="Category Allocated" key="2">
            <div className="tabHeading">
              List of all podcast category allocated
            </div>
            <div className="categoryAllocatedList">
              <Row gutter={16}>
                {listCategoryTenant?.map((data, index) => (
                  <Col xs={24} sm={6}>
                    <div className="categoryItem">
                      <div className="imgBx">
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}/${data?.image_url}`}
                          alt={Img1}
                        />
                      </div>
                      <span>{data?.name_en}</span>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </TabPane>
          <TabPane tab="User Details" key="3">
            <div>
              <UserListView />
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </>
  );
};

export default ViewTenantDetails;
